import script from "./AttachmentsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./AttachmentsList.vue?vue&type=script&lang=ts&setup=true"

import "./AttachmentsList.vue?vue&type=style&index=0&id=3775577d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3775577d"]])

export default __exports__